<!-- 学员标签管理 -->
<template>
  <div class="basicStyle">
    <div class="bg_fff">
      <div class="querySearch">
        <div class="searchItem">
          <span>标签名称</span>
          <el-input
            v-model="queryInfo.name"
            clearable
            size="small"
            placeholder="请输入标签名称"
          ></el-input>
        </div>
        <!-- <el-button type="primary" size="small" @click="queryTable('search')"
        >搜索</el-button
      >
      <el-button type="warning" size="small" @click="resetQuery"
        >重置</el-button
      > 
      <el-button type="danger" size="small" @click="tagDetail"
        >通用标签设置</el-button
      >
      -->

        <MyButton
          value="搜索"
          size="medium"
          icon="el-icon-search"
          type="1"
          @click="queryTable('search')"
        ></MyButton>
        <MyButton
          value="重置"
          size="medium"
          type="2"
          @click="resetQuery"
        ></MyButton>
        <MyButton
          value="通用标签设置"
          size="medium"
          type="3"
          @click="tagDetail"
        ></MyButton>
      </div>
      <div class="addInfo">
        <MyButton
          value="新增"
          size="medium"
          icon="el-icon-folder-add"
          type="1"
          @click="viewDetail"
        ></MyButton>
      </div>
      <div class="table">
        <TableComponents :columns="columns" :tableData="tableList">
          <template slot="operation" slot-scope="{ row }">
            <span class="operationItem" @click="viewDetail(row)">编辑</span>
            <span class="operationItem" @click="deleteData(row)">删除</span>
          </template>
        </TableComponents>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[10, 30, 50, 80]"
          :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryInfo.total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新增编辑弹窗 -->
    <el-dialog
      :title="dialogType"
      :visible.sync="addFormShow"
      class="formDialog"
      width="500px"
    >
      <el-form
        :model="userInfo"
        :rules="rules"
        ref="userInfoForm"
        label-width="100px"
      >
        <el-form-item label="标签名称：" prop="name">
          <el-input
            v-model="userInfo.name"
            placeholder="请输入标签名称"
            size="mini"
            maxlength="10"
            show-word-limit
            @input="$forceUpdate()"
          ></el-input>
        </el-form-item>
        <el-form-item label="序号：" prop="sorted">
          <el-input
            v-model="userInfo.sorted"
            placeholder="请输入序号"
            size="mini"
            @input="$forceUpdate()"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态：" prop="status">
          <el-radio-group v-model="userInfo.status" size="mini">
            <el-radio-button :label="1">启用</el-radio-button>
            <el-radio-button :label="0">禁用</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addUser('userInfoForm')" size="mini"
          >确 定</el-button
        >
        <el-button @click="addFormShow = false" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="tagVisible"
      class="formDialog"
      width="500px"
    >
      <!-- 通用标签设置 -->
      <el-checkbox
        v-model="tagForm.is_use_userext_common_tag"
        :true-label="1"
        :false-label="0"
        >使用学员管理通用标签</el-checkbox
      >
      <div class="tagDetail" v-html="labelxygl"></div>
      <el-checkbox
        v-model="tagForm.is_use_crm_common_tag"
        :true-label="1"
        :false-label="0"
        >使用外呼通用标签</el-checkbox
      >
      <div class="tagDetail" v-html="labelwh"></div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tagSave()" size="mini"
          >保存</el-button
        >
        <el-button @click="tagClose()" size="mini">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonApi from "@/api/common";
import studentApi from "@/api/student.js";
import { clearObj, copyToClip } from "@/utils/index.js";
import TableComponents from "@/components/TableComponents.vue";
import MyButton from "@/components/MyButton.vue";
export default {
  name: "labelManage",
  components: {
    TableComponents,
    MyButton,
  },
  data() {
    return {
      queryInfo: {
        limit: 10,
        page: 1,
        total: 0,
        name: "",
      },
      columns: [
        //列数据
        { label: "标签ID", prop: "id" },
        { label: "标签名称", prop: "name" },
        { label: "创建人", prop: "create_user" },
        { label: "创建时间", prop: "created_at" },
        { label: "更新人", prop: "update_user" },
        { label: "状态", prop: "status" },
        { label: "更新时间", prop: "updated_at" },
        { label: "操作", prop: "operation" },
      ],
      tableList: [],
      // 新增编辑表单数据
      addFormShow: false,
      userInfo: {
        name: "",
        id: "",
        status: "",
      },
      rules: {
        name: [{ required: true, message: "请输入标签名称", trigger: "blur" }],
      },
      max_sorted: 0,
      tagVisible: false,
      labelxygl: "",
      labelwh: "",
      tagForm: {
        is_use_crm_common_tag: 0,
        is_use_userext_common_tag: 0,
      },
    };
  },
  computed: {
    dialogType() {
      return this.userInfo.id ? "编辑" : "新增";
    },
  },
  watch: {
    addFormShow: {
      handler(_newVal) {
        if (!_newVal) {
          clearObj(this.userInfo);
        }
      },
    },
  },
  created() {
    this.getDic();
    this.queryTable();
  },
  methods: {
    // 通用标签设置取消
    tagClose() {
      this.resetQuery();
      this.tagVisible = false;
    },
    // 通用标签设置保存
    tagSave() {
      commonApi.tobCommonTagDo(this.tagForm).then((res) => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "保存成功!",
          });
          this.queryTable();
          this.tagVisible = false;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    getDic() {
      commonApi.getInfoToName({ name: "outwardcalsm" }).then((res) => {
        res.data.forEach((item) => {
          if (item.key == "labelxygl") {
            this.labelxygl = item.value;
          }
          if (item.key == "labelwh") {
            this.labelwh = item.value;
          }
        });
      });
    },

    // 通用标签设置
    tagDetail() {
      this.tagVisible = true;
    },
    // 列表数据
    async queryTable(_type) {
      if (_type) {
        this.queryInfo.page = 1;
      }
      const res = await studentApi.tobTagsList(this.queryInfo);
      if (res.code == 200) {
        this.queryInfo.total = res.data.total;
        this.tableList = res.data.data;

        this.tagForm.is_use_crm_common_tag = res.data.is_use_crm_common_tag;
        this.tagForm.is_use_userext_common_tag =
          res.data.is_use_userext_common_tag;

        this.max_sorted = res.data.max_sorted;
        this.tableList.forEach((item, index) => {
          this.tableList[index].sortId =
            (this.queryInfo.page - 1) * this.queryInfo.limit + (index + 1);
        });
      } else {
        this.$message.error(res.message);
      }
    },
    // 打开弹窗
    viewDetail(row) {
      //  row);
      if (row.id) {
        Object.assign(this.userInfo, row);
      } else {
        this.userInfo.sorted = this.max_sorted;
        this.userInfo.status = 1;
      }
      this.addFormShow = true;
    },
    // 添加｜｜修改数据
    addUser(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res;
          if (this.userInfo.id) {
            res = await studentApi.tobTagsEdit(this.userInfo);
          } else {
            res = await studentApi.tobTagsAdd(this.userInfo);
          }
          if (res.code == 200) {
            this.$message.success(`${this.dialogType}成功`);
            this.queryTable();
            this.addFormShow = false;
          } else {
            this.$message.error(res.message);
          }
        } else {
          //  'error submit!!');
          return false;
        }
      });
    },
    // 删除数据
    deleteData(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await studentApi.tobTagsDelete({ id: row.id });
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.queryTable();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    editCode(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("修改成功!");
          this.resetCodeShow = false;
        } else {
          return false;
        }
      });
    },
    // 重置
    resetQuery() {
      this.queryInfo = {
        limit: 10,
        page: 1,
        total: 0,
        name: "",
      };
      this.queryTable();
    },
    // 分页
    handleSizeChange(e) {
      //  e);
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin-right: 50px;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 250px;
        padding: 5px 0;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin: 10px 0;
  }

  // 表格数据
  .table {
    // min-height: calc(100vh - 330px);
  }
  .operationItem {
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: rgb(87, 87, 239);
  }
  .operationItem:hover {
    color: red;
  }

  // 分页
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px;
  }

  /deep/ .formDialog {
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
    .roleStyle {
      .el-form-item__content {
        display: flex;
        align-items: center;
        .el-form-item__content {
          margin-left: 0 !important;
        }
        img {
          width: 20px;
          height: 20px;
          margin-left: 10px;
          cursor: pointer;
        }
        .el-button {
          border: none;
          padding-left: 5px;
        }
        .el-button:focus,
        .el-button:hover {
          background-color: #fff;
        }
      }
    }
  }

  /deep/.tagDetail {
    padding: 10px;
    border: 1px solid #ddd;
    margin: 10px 0;
  }
}
</style>
